import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { PurchaseOrderDetails } from '../types/PurchaseOrderDetails';

export const useGetPurchaseOrder = (purchaseOrderID: number) => {
    const { data, isLoading, refetch, isRefetching } = useQuery({
        queryKey: ['purchase-order', purchaseOrderID],
        queryFn: async () => await apiClient.get('purchase-order/details',
            {
                params: {
                    purchaseOrderID: purchaseOrderID
                }
            }) as PurchaseOrderDetails
    });

    return {
        data,
        isLoading,
        refetch,
        isRefetching
    };
};
